import RezervacniFormular from "./RezervacniFormular.svelte";

let target = document.querySelector("div#rezervace");


if(target) {
    if(typeof window.RezervacniFormularProps !== "undefined") 
    {
        const form = new RezervacniFormular({
            target: target,
            props: window.RezervacniFormularProps
        });
    }
    else {
        const form = new RezervacniFormular({
            target: target,
            props: {
                kontakty: {
                    telefon : "+420 792 283 727",
                    email: "studionatalis@seznam.cz"
                },
                rezervacni_mista: [
                    {
                        id: "natalia_skácelová",
                        nazev: "Natalia Skácelová",
                    },
                    {
                        id: "studio_natalis",
                        nazev: "Studio Natalis",
                    },
                ]
            }
        });
    }

}
else {
    console.log("Došlo k chybě, nelze najít RS_Form prvek v dokumentu.");
}